import React, { SVGProps } from 'react'
const SvgSidenavHomeActive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      d="M9.293 3.207 3.889 8.611V16.5a1 1 0 0 0 1 1h1.889a1 1 0 0 0 1-1v-3.444a2.222 2.222 0 1 1 4.444 0V16.5a1 1 0 0 0 1 1h1.89a1 1 0 0 0 1-1V8.611l-5.405-5.404a1 1 0 0 0-1.414 0Z"
    />
    <path
      stroke={props.stroke || 'var(--color-cta)'}
      strokeLinecap="round"
      strokeWidth={1.5}
      d="m1.667 10.833 2.222-2.222m14.444 2.222-2.222-2.222m-12.222 0 5.404-5.404a1 1 0 0 1 1.414 0l5.404 5.404m-12.222 0V16.5a1 1 0 0 0 1 1h1.889a1 1 0 0 0 1-1v-3.444c0-1.228.995-2.223 2.222-2.223v0c1.227 0 2.222.995 2.222 2.223V16.5a1 1 0 0 0 1 1h1.89a1 1 0 0 0 1-1V8.611"
    />
  </svg>
)
export default SvgSidenavHomeActive
